import React from 'react';

import {Container, Row, Card} from 'react-bootstrap';

import {ICoursePreview} from 'shared/utils/course-preview';

import {CoursePreviewModal} from './CoursePreviewModal';

import './styles.scss';

interface ICoursesSectionProps {
    currentCourses: ICoursePreview[];
}

export const CoursesSection = ({currentCourses}: ICoursesSectionProps) => {
    const [show, setShow] = React.useState<boolean>(false);
    const [currentCoursePreview, setCurrentCoursePreview] = React.useState<ICoursePreview | undefined>();

    const handleClick = (course: ICoursePreview) => {
        setShow(true);
        setCurrentCoursePreview(course);
    };

    return (
        <>
            <section className="courses-section">
                <Container>
                    <h2 className="section-title">Explore Our Courses</h2>
                    <Row className="gy-4">
                        {currentCourses.map(course => (
                            // <Col key={course.id} md={4}>
                                <Card
                                    className="course-card"
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => handleClick(course)}
                                >
                                    <Card.Img variant="top" src={course.imgSRC} alt={course.shortName || course.name} />
                                    <Card.Body>
                                        <Card.Title className="mb-0 text-center card-course-title">{course.shortName || course.name}</Card.Title>
                                    </Card.Body>
                                </Card>
                            // </Col>
                        ))}
                    </Row>
                    {/* <h2 className="section-title mt-5">Upcoming Courses</h2>
                    <Row className="gy-4">
                        {upcomingCourses.map((course, index) => (
                            <Col key={index} md={4}>
                                <Card className="course-card course-card--upcoming">
                                    <Card.Img variant="top" src={comingSoonBannerSRC} alt={course.name} />
                                    <Card.Body>
                                        <Card.Title className="mb-0 text-center">{course.name}</Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row> */}
                </Container>
            </section>
            <CoursePreviewModal onHide={() => setShow(false)} show={show} coursePreview={currentCoursePreview} />
        </>
    );
};